<app-table-custom [tableData]="tableData"
                  [data]="produtos">
</app-table-custom>
